/*
 * @Author: your name
 * @Date: 2021-04-15 11:24:30
 * @LastEditTime: 2021-08-27 08:56:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\vant.js
 */

// 按需全局引入 vant组件
import Vue from 'vue'
import { Button, List, Tabbar, TabbarItem, NavBar, Icon, ActionSheet } from 'vant'
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';
import { Grid, GridItem } from 'vant';
import { Image as VanImage } from 'vant';
import { Cell, CellGroup } from 'vant';
import { IndexBar, IndexAnchor } from 'vant';
import { Tab, Tabs, Toast, Tag } from 'vant';
import { Popup } from 'vant';
import { Field } from 'vant';
import { ShareSheet } from 'vant';
import { Uploader } from 'vant';
import { PullRefresh } from 'vant';
import { Stepper } from 'vant';
import { Overlay } from 'vant';
import { Dialog } from 'vant';
import { Loading } from 'vant';
import { Progress } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant'
import { RadioGroup, Radio } from 'vant';
import { ImagePreview } from 'vant';
import { Empty } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Search } from 'vant';
import { Notify } from 'vant';
import { DatetimePicker } from 'vant';
import { Calendar } from 'vant';
import { Sticky } from 'vant';
import { Popover } from 'vant';
import { Rate } from 'vant';

Vue.use(Rate);
Vue.use(Popover);
Vue.use(Sticky);
Vue.use(Calendar);
Vue.use(DatetimePicker);
Toast.setDefaultOptions({ duration: 2000 });
Vue.use(Search);
Vue.use(Field);
Vue.use(GoodsAction);
Vue.use(GoodsActionIcon);
Vue.use(GoodsActionButton);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(VanImage);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Button)
Vue.use(List)
Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Icon)
Vue.use(Popup);
Vue.use(Field);
Vue.use(ShareSheet);
Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Uploader);
Vue.use(Tag);
Vue.use(PullRefresh);
Vue.use(Stepper);
Vue.use(Dialog);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Progress);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(ImagePreview);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Empty);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Notify);
